import React, { useMemo } from 'react';
import { GenericListPage } from '../../../components/generic';
import { usePmsEquipmentInstances, PmsEquipmentInstance } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  const config = useMemo(
    () => ({
      ...moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions,
    }),
    [],
  );
  return <GenericListPage<PmsEquipmentInstance> useData={usePmsEquipmentInstances} config={config} />;
};

export default List;
